import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import SpeedDial from '@material-ui/lab/SpeedDial'
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon'
import SpeedDialAction from '@material-ui/lab/SpeedDialAction'
import { Airplay, FileCopy } from '@material-ui/icons'
import PropTypes from 'prop-types'
import { primaryColor, secondaryColor } from '../../../../../constants'
import IntelMsg from '../../../../ItelMsg'

const useStyles = makeStyles((theme) => ({
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: 'fixed',
    'z-index': '900',

    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
      bottom: theme.spacing(2),
      right: theme.spacing(8),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
    '& > button': {
      backgroundColor: primaryColor,
    },
    '& > button:hover': {
      backgroundColor: secondaryColor,
    },
  },
}))

const SpeedDials = ({ show, setShow, showDeviceBulk, setDeviceBulkShow }) => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <SpeedDial
      ariaLabel="actions"
      className={classes.speedDial}
      hidden={(show, showDeviceBulk)}
      icon={<SpeedDialIcon />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      direction="up"
      FabProps={{ backgroundColor: primaryColor }}
    >
      <SpeedDialAction
        key="Add Asset"
        icon={<Airplay />}
        tooltipTitle={
          <h5>
            <IntelMsg id="addTankDeviceAction" />
          </h5>
        }
        onClick={() => {
          handleClose()
          setShow(true)
        }}
      />
      <SpeedDialAction
        key="Bulk upload"
        icon={<FileCopy />}
        tooltipTitle={
          <h5>
            <IntelMsg id="bulkUploadAction" />
          </h5>
        }
        onClick={() => {
          handleClose()
          setDeviceBulkShow(true)
        }}
      />
      {/* <SpeedDialAction
        key="Bulk Config"
        icon={<PhonelinkSetup />}
        tooltipTitle={
          <h5>
            <IntelMsg id="bulkConfigAction" />
          </h5>
        }
        onClick={handleClose}
      /> */}
    </SpeedDial>
  )
}

SpeedDials.propTypes = {
  setShow: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  setDeviceBulkShow: PropTypes.func.isRequired,
  showDeviceBulk: PropTypes.bool.isRequired,
}
export default SpeedDials
